
export default {
    name: 'LangSwitch',
    computed: {
        lagnuages() {
            return [
                {
                    title: this.$t('i18n.languages.ru'),
                    key: 'ru'
                },
                {
                    title: this.$t('i18n.languages.en'),
                    key: 'en'
                }
            ];
        },
        fakeSelectCapture() {
            return this.lagnuages.find(lang => lang.key === this.$i18n.locale).title;
        }
    }
};
